import { FC, useCallback, useEffect, useState } from 'react';
import { InputSelect } from '@features/ui';
import { reportData } from '@features/admin/reports/reportData.ts';
import {
  ReportType,
  TReportNewUserByMonth,
  TReportNewUserByMonthParams,
} from '@src/types';
import { ReportChart } from '@features/admin/reports/ReportChart.tsx';
import { useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { getNewUserByMonth } from '@src/services/reports.ts';

export const ReportDashboard: FC = () => {
  const [selectedReportType, setSelectedReportType] = useState<ReportType>(
    ReportType.USERS_NEW_USERS_BY_MONTH
  );
  const [data, setData] = useState<TReportNewUserByMonth[]>([]);

  const navigate = useNavigate();

  const fetchData = async (params?: TReportNewUserByMonthParams) => {
    const res = await getNewUserByMonth(params);

    setData(res);
  };

  useEffect(() => {
    fetchData().then();
  }, []);

  const handleSelectReport = useCallback(
    (value: ReportType) => {
      setSelectedReportType(value);
      const params = {
        type: value,
      };
      const searchString = queryString.stringify(params);

      navigate({
        pathname: '/admin/reports',
        search: searchString,
      });
    },
    [navigate]
  );

  return (
    <div>
      <div className={'flex justify-between'}>
        <h1 className={'text-[23px]'}>Reports</h1>
        <div className={'flex gap-7.5'}>
          <InputSelect
            className={'w-[239px] border-[#C6C6C6]'}
            options={reportData}
            placeholder={'Select a report'}
            value={selectedReportType}
            onChange={(value) => handleSelectReport(value as ReportType)}
          />
        </div>
      </div>
      <ReportChart data={data} refetchData={fetchData} />
    </div>
  );
};
